import api from '../../services/api';

const urlBase = '/contratantes';

export default {
	listar: () => api.get(urlBase),
	criar: (data) => api.post(urlBase, data),
	atualizar: (contratanteId, data) => api.put(`${urlBase}/${contratanteId}`, data),
	excluir: (contratanteId) => api.delete(`${urlBase}/${contratanteId}`),
};